<template>
  <div>
    <div id="registrationHistory" class="modal" role="dialog">
      <div class="modal-dialog modal-lg custom-view-history-modal-class">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <section>
              <div class="col-xs-12 p-16 d-flex align-items-center justify-content-between header-wrapper">
                <div class="modal-header-title fw-600 font-20">{{ $t('viewHistory') }}</div>
                <img
                  class="pr-5 cursor-pointer"
                  src="/static/images/icons/emergo_modal_close.svg"
                  data-dismiss="modal"
                />
              </div>
            </section>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12">
                <div class="col-xs-12 history-wrapper">
                  <div
                    class="col-xs-12 p-0 view-item-history active"
                    v-for="(history, index) in historyData"
                    :key="index"
                  >
                    <section>
                      <div class="col-xs-12 p-0 cursor-pointer" @click="viewHistoryChanges(index)">
                        <div class="view-history-title d-flex justify-content-between">
                          <div class="view-history-title-version emergo-primary-text">
                            {{ $t('version') }} {{ history.versionNumber }}
                            <span v-if="index === 0 && history.isRenewed"
                              >({{ $t('current') }} / {{ $t('renewed') }})</span
                            >
                            <span v-else-if="index === 0">({{ $t('current') }})</span>
                            <span v-else-if="history.isRenewed">({{ $t('renewed') }})</span>
                          </div>
                          <div class="edited-details mt-8 font-14">
                            <span v-if="index < historyData.length - 1">
                              {{ history.registrationData.modified_on}}
                            </span>
                            <span v-else>
                              {{ history.registrationData.created_on}}
                            </span>
                          </div>
                        </div>
                        <div class="col-xs-12 p-0 edited-details mt-8 font-14">
                          <span v-if="history.isRenewed">{{ $t('renewed') }}</span>
                          <span v-else-if="index < historyData.length - 1">{{ $t('edited') }}</span>
                          <span v-else>{{ $t('created') }}</span>
                          <span v-if="index < historyData.length - 1">
                            {{ history.registrationData.modified_by_name }}
                          </span>
                          <span v-else>
                            {{ history.registrationData.createdByName }}
                          </span>
                        </div>
                      </div>
                    </section>
                    <div
                      class="view-history-details panel-collapse collapse"
                      :class="{
                        'display-block': viewHistoryFlagList.indexOf(index) > -1
                      }"
                    >
                      <div class="col-xs-12 p-0">
                        <ul class="m-0">
                          <li v-for="changes in history.registrationModificationsData" :key="changes.key">
                            {{ $t('changed') }} {{ changes.key }} {{ $t('from') }}
                            {{ changes.oldVal }}
                            {{ $t('to') }}
                            {{ changes.newVal }}
                          </li>
                          <li v-for="change in history.attachmentModificationData" :key="change.key">
                            {{ change }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="clear: both;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: ['historyData'],
  data() {
    return {
      showChanges: false,
      showChangesText: 'View Changes',
      viewHistoryFlagList: []
    };
  },
  mounted() {},
  methods: {
    viewHistoryChanges(index) {
      if (index !== this.historyData.length - 1) {
        const value = this.viewHistoryFlagList.indexOf(index);
        if (value === -1) {
          this.viewHistoryFlagList.push(index);
        } else {
          this.viewHistoryFlagList = this.viewHistoryFlagList.filter((n) => n !== index);
        }
      }
    },
    enableSaveButton(data) {
      this.enableSave = data;
    },
    toggleChangesBtn() {
      console.log(this.showChanges);
      this.showChanges = !this.showChanges;
      console.log(this.showChanges);
      this.showChangesText = this.showChanges ? 'Hide Changes' : 'View Changes';
    }
  },
};
</script>
<style scoped>
.p-16 {
  padding: 16px;
}

.header-wrapper {
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 24px;
}

.history-wrapper {
  padding: 0px 40px 23px 32px;
  min-height: 35vh;
  max-height: 45vh;
  overflow-y: auto;
}

.mt-8 {
  margin-top: 8px;
}

.edited-details {
  color: #3e3e3e;
  line-height: 19px;
}

.view-item-history {
  padding: 0px 0px 19px 0px;
  margin-bottom: 23px;
  border-bottom: 1px solid #d3d3d3;
}

.custom-view-history-modal-class .modal-header {
  background: #ffffff !important;
  border-bottom: none !important;
  padding: 0px;
  border-radius: 8px;
  color: #1a1a1a;
}
.custom-view-history-modal-class .modal-content {
  border-radius: 8px !important;
}
.view-history-title-version {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  /* display: inline;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7); */
}
.history-edit-details {
  font-family: 'Open Sans';
  padding-top: 7px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #828282;
}
.view-history-display-changes {
  float: right;
  cursor: pointer;
}
.history-view-changes {
  border: none;
  background: transparent;
  outline: none;
  font-size: 16px;
  color: #01518a;
  font-weight: 600;
}
.view-history-details ul {
  /* padding-bottom: 14px; */
  padding-top: 24px;
}
.view-history-details ul li {
  /* list-style-type: none; */
  font-family: 'Open Sans';
  padding-bottom: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.custom-view-history-modal-class {
  margin-top: 4%;
  width: 600px;
  margin-bottom: 50px;
}
.custom-view-history-modal-class .modal-body {
  padding: 0px;
}

.modal-open .modal {
  overflow-y: auto;
  overflow-x: hidden;
}
.container-fluid {
  padding: 0px 40px 0px 40px;
}
.modal-header-title {
  line-height: 27px;
  color: #1a1a1a;
  /* font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 44px;
  color: #333333;
  padding: 24px 0px 18px 24px; */
}
.close-icon {
  position: absolute;
  right: 24px;
  top: 24px;
}
.close-icon img {
  cursor: pointer;
}
.header-hr-outer {
  padding: 0px 24px 26px 24px;
}
.header-hr-outer hr,
.body-hr-outer hr {
  margin: 0px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.body-hr-outer {
  padding: 21px 0px 21px 0px;
}

.modal-footer {
  border-radius: 8px;
  background: #fafaf9;
  border-top: none !important;
  padding: 40px;
}

.history-wrapper::-webkit-scrollbar {
  width: 6px;
}
.history-wrapper::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  outline: none;
}
.history-wrapper::-webkit-scrollbar-track {
  box-shadow: none;
}
</style>
